import React from 'react';
import PropTypes from 'prop-types';

import AdminPlaceholder from 'components/consumer/AdminPlaceholder';

const withAdminPlaceholderHOC = ({
  componentName = '',
}) => WrappedComponent => {
  const WrappedComponentWithAdminPlaceholder = ({ isAdmin, ...props }) => {
    if (isAdmin) {
      return (
        <AdminPlaceholder>
          {componentName} Placeholder for Variant Builder. <br />
          The component will display in Consumer
        </AdminPlaceholder>
      );
    }

    return <WrappedComponent {...props} />;
  };

  WrappedComponentWithAdminPlaceholder.propTypes = {
    isAdmin: PropTypes.bool,
  };

  return WrappedComponentWithAdminPlaceholder;
};

export default withAdminPlaceholderHOC;
